document.addEventListener('DOMContentLoaded', () => {
  const header = document.getElementById('header');

  if (!header) {
    console.warn('⚠️ No se encontró el header con id="header"');
    return;
  }

  const navbar = document.getElementById('navbarNav');
  const toggler = header.querySelector('.navbar-toggler');
  const isMenuOpen = () => navbar && navbar.classList.contains('show');

  const updateHeader = () => {
    if (window.scrollY > 50 || isMenuOpen()) {
      header.classList.add('header-scrolled');
    } else {
      header.classList.remove('header-scrolled');
    }
  };

  window.addEventListener('scroll', updateHeader);

  if (navbar && toggler) {
    // Darkblue header + animate items while the menu opens
    navbar.addEventListener('show.bs.collapse', () => {
      header.classList.add('header-scrolled');
      navbar.classList.add('nav-open');
    });
    navbar.addEventListener('hide.bs.collapse', () => navbar.classList.remove('nav-open'));
    navbar.addEventListener('hidden.bs.collapse', updateHeader);

    // Close on tap outside (reuse toggler; avoid a 2nd bootstrap import)
    document.addEventListener('click', (event) => {
      if (isMenuOpen() && !header.contains(event.target)) {
        toggler.click();
      }
    });
  }
});
